import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { applyCatalogOverride } from "@/lib/kalkulatorCatalog";

// Fetches the admin-managed RAB catalog once per session and applies it over the hardcoded
// defaults in kalkulatorCatalog.js — every screen that already imports CAT/LANTAI_CAT/
// MEK2_TIERS picks up the change automatically (see applyCatalogOverride's comment). Until
// this resolves (or if the backend has nothing saved yet — first-ever run), the calculator
// keeps working off the hardcoded defaults, so there's never a blank-catalog state.
export default function useKalkulatorCatalog() {
  return useQuery({
    queryKey: ["kalkulator-catalog"],
    queryFn: async () => {
      const { data } = await api.get("/settings/kalkulator-catalog");
      if (data && Object.keys(data).length) applyCatalogOverride(data);
      return data;
    },
    staleTime: 5 * 60_000,
  });
}
